import { render, staticRenderFns } from "./kendo-treemap.vue?vue&type=template&id=76c51962&scoped=true"
import script from "./kendo-treemap.vue?vue&type=script&lang=js"
export * from "./kendo-treemap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c51962",
  null
  
)

export default component.exports